import { render, staticRenderFns } from "./ProcedureDomainMoveOutAccount.vue?vue&type=template&id=75b38f12&"
import script from "./ProcedureDomainMoveOutAccount.vue?vue&type=script&lang=ts&"
export * from "./ProcedureDomainMoveOutAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports